import { render, staticRenderFns } from "./WaitApprovalList.vue?vue&type=template&id=20a7eb1e&"
import script from "./WaitApprovalList.vue?vue&type=script&lang=js&"
export * from "./WaitApprovalList.vue?vue&type=script&lang=js&"
import style0 from "./WaitApprovalList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports